import "../../../node_modules/video-react/dist/video-react.css"; // import css
import "./Home.css";
import {
  MainCarousel,
  CategoryCard,
  ModalMessage,
  LoadingSpinner,
} from "../../components";
import Container from "react-bootstrap/esm/Container";
import { useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import { fetchBestSellersApi } from "../../api/productsApi";
import { LinkContainer } from "react-router-bootstrap";
import { Button, Image, Row, Col } from "react-bootstrap";
import { Player, ControlBar, BigPlayButton } from "video-react";
import posterImage from "../../assets/images/posterImage.jpg";

export default function Home() {
  const categoriesListRef = useRef(null);
  const categories = useSelector((state) => state.categories) || [];
  const { topVideo, topImage, topOverlayText } = useSelector(
    (state) => state.appConfig
  );

  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loadingError, setLoadingError] = useState(false);
  const [bestSellers, setBestSellers] = useState([]);

  const scrollToCategories = () => {
    if (categoriesListRef.current) {
      categoriesListRef.current.scrollIntoView({ behaviour: "smooth" });
    }
  };

  useEffect(() => {
    const abortController = new AbortController();

    const fetchBestSellers = async () => {
      // home page displays the header + main categories + bestsellers
      try {
        setIsLoading(true);
        const res = await fetchBestSellersApi(abortController.signal);
        setIsLoading(false);
        return res;
      } catch (error) {
        console.log("Could not load bestseller data. Please try again later.");
      }
    };

    fetchBestSellers()
      .then((res) => {
        setBestSellers(res);
      })
      .catch((error) =>
        console.log("Could not load bestseller data. Please try again later.")
      );

    return () => {
      abortController.abort();
    };
  }, []);

  const ImageOverlay = (
    <div className="image-overlay">
      <div style={{ textAlign: "center", width: "90%" }}>
        <Button
          variant="dark rounded-5"
          size="lg"
          className="fade-in overlay-button"
          onClick={scrollToCategories}
        >
          Shop now
        </Button>
        <div>
          <h1 className="fade-in overlay-text">{topOverlayText}</h1>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {errorMsg && (
        <ModalMessage
          type="danger"
          message={errorMsg}
          setErrorMsg={setErrorMsg}
        />
      )}
      {/* TOP IMAGE */}
      {(isLoading || categories?.length < 1) && <LoadingSpinner />}
      {!isLoading && (
        <div>

          {!topVideo && topImage && (
            <div style={{ position: "relative" }}>
              <Image
                src={topImage.url}
                style={{ width: "100%" }}
                onError={() => setLoadingError(true)}
              />
              {ImageOverlay}
            </div>
          )}

          {/* TOP VIDEO */}
          {topVideo && (
            <div style={{ position: "relative" }}>
              <Player
                playsInline
                preload="auto"
                muted={true}
                autoPlay
                loading="lazy"
                controls={false}
                poster={posterImage}
                src={topVideo?.url}
              >
                <ControlBar disableCompletely={true} />
                <BigPlayButton position="center" />
              </Player>

              {ImageOverlay}
            </div>
          )}
          {(loadingError || (!topVideo && !topImage)) && topOverlayText && (
            <div className="top-banner fade-in">
              <h2 className="fade-in">{topOverlayText}</h2>
            </div>
          )}

          {/* CATEGORY CARDS */}
          <Container className="mt-5" ref={categoriesListRef}>
            {categories.length > 0 && (
              <>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h2 style={{ display: "inline" }}>Top Categories</h2>
                  <LinkContainer to="product-list">
                    <Button
                      variant="outline-secondary rounded-5"
                      className="d-flex align-items-center"
                    >
                      Shop all Categories
                    </Button>
                  </LinkContainer>
                </div>

                <Row
                  xs={2}
                  md={3}
                  className="g-4 mt-1 "
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  {" "}
                  {categories?.map((category, index) => {
                    return (
                      <Col key={category._id}>
                        <CategoryCard category={category} />
                      </Col>
                    );
                  })}
                </Row>
              </>
            )}

            {/* BEST SELLERS CAROUSEL */}
            {bestSellers.length > 0 && 
            <div>
              <div
                className="mt-5"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <h2 style={{ display: "inline" }}>Best Sellers</h2>
                <LinkContainer to="product-list">
                  <Button
                    variant="outline-secondary rounded-5"
                    className="d-flex align-items-center"
                  >
                    Shop all Products
                  </Button>
                </LinkContainer>
              </div>
              <div className="mt-4">
                <MainCarousel items={bestSellers} />
              </div>
            </div>}
          </Container>
        </div>
      )}
    </>
  );
}
